import { Button, Stack, Typography } from "@mui/material";
import React from "react";
import { colours, boxShadows } from "./StyleConstants";
import logo from "./images/lasso_logo_inline.svg";

type State = {
    hasError: boolean,
    error: any
}

export default class ErrorBoundary extends React.Component<any, State> {
    constructor(props: any) {
        super(props);
        this.state = {
            hasError: false,
            error: undefined
        };
    }

    static getDerivedStateFromError(error: any) {
        return {
            hasError: true,
            error: error
        };
    }

    render() {
        const error = this?.state?.error
        if (this.state?.hasError) {
            if (error.message === "451") {
                return <ErrorEmailPage/>;
            }
            return <ErrorPage/>;
        } else {
            return this.props.children;
        }
    }
}

function ErrorPage() {
    return (
        <Stack
            height="100vh"
            justifyContent="center"
            alignItems="center"
            sx={{ backgroundColor: colours.midnightBlue.blueBG }}
        >
            <Stack
                alignItems="center"
                padding="72px"
                boxShadow={boxShadows.levelTwo}
                sx={{ backgroundColor: colours.core.white }}
                gap={4}
            >
                {errorLogo()}
                <Typography fontSize="32px" fontWeight={600} textAlign="center">
                    Oops something went wrong...
                </Typography>
                <Typography textAlign="center">
                    Something went wrong when connecting to the platform, please try refreshing the page.
                </Typography>
            </Stack>
        </Stack>
    );
}

function ErrorEmailPage() {
    return (
        <Stack
            height="100vh"
            justifyContent="center"
            alignItems="center"
            sx={{ backgroundColor: colours.midnightBlue.blueBG }}
        >
            <Stack
                alignItems="center"
                justifyContent="space-between"
                height="60%"
                width="50%"
                padding="72px"
                boxShadow={boxShadows.levelTwo}
                sx={{ backgroundColor: colours.core.white }}
                gap={4}
            >
                {errorLogo()}
                <Typography fontSize="40px" fontWeight={600}>
                    Restricted email domain was used.
                </Typography>
                <Typography textAlign="center">
                    Only institutional email addresses are allowed for access. Email domains such as Gmail, Yahoo,
                    Hotmail, and other public services are not supported. Please use an institutional email address
                    associated with your organization or university.
                </Typography>
                <Button
                    component="a"
                    href={window.location.href}
                    rel="noopener noreferrer"
                    variant="outlined"
                    sx={{
                        color: colours.midnightBlue.blue,
                        borderColor: colours.midnightBlue.blue,
                        padding: "12px 24px",
                        textTransform: "none",
                        borderWidth: "2px",
                        borderRadius: "8px",
                        fontWeight: "bold",
                        fontSize: "16px",
                        "&:hover": {
                            backgroundColor: colours.midnightBlue.blue,
                            color: "white",
                            borderColor: colours.midnightBlue.blue,
                            borderWidth: "2px"
                        },
                    }}
                >
                    Go back to login
                </Button>
            </Stack>
        </Stack>
    );
}

function errorLogo() {
    return (<img src={logo} style={{ width: "45%" }} alt="Logo"/>)
}